
import Layout from '@/pages/layout'
import {
	zzshRoutes,
	dyjyRoutes,
	dwgzRoutes,
	djxcRoutes,
	dqgjRoutes,
	xtszRoutes,
	messRoutes
 } from "./permission.js"
export const navs = [
	{
		path:"/",
		name:"组织概况",
		redirect:'/zbgk',
		meta: {
			activeMenu: '/zbgk', // 顶部导航 高亮
		},
		component:Layout,
		children:[
			{
				path:"/zbgk",
				name:"组织概况 ",
				component: () => import('@/pages/zbgk'),
				meta: {
					activeMenu: '/zbgk',// 顶部导航 高亮
					requiresAuth:[1,2,3]
				}
			}
		]
	},
	{
		path:"/zzsh",
		name:"组织生活",
		component:Layout,
		redirect:'/shyk',
		icon:require('@/assets/images/dygl_icon.png'),
		meta: {
			activeMenu: '/zzsh', // 顶部导航 高亮
		},
		children:[
			...zzshRoutes
		]
	},
	{
		path:"/dyjy",
		name:"党员教育",
		redirect:'/grxxjl',
		icon:require('@/assets/images/dygl_icon.png'),
		component:Layout,
		meta: {
			activeMenu: '/dyjy', // 顶部导航 高亮
		},
		children:[
			...dyjyRoutes
		]
	},
	{
		path:"/dwgz",
		name:"党务工作",
		component:Layout,
		redirect:'/dzz'||'dyxxgl',
		icon:require('@/assets/images/dwgl.png'),
		meta: {
			activeMenu: '/dwgz', // 顶部导航 高亮
		},
		children:[
			...dwgzRoutes
		]
	},
	{
		path:"/djxc",
		name:"党建宣传",
		component:Layout,
		redirect:'/djxc_ywzx',
		icon:require('@/assets/images/djxc_icon.png'),
		meta: {
			activeMenu: '/djxc', // 顶部导航 高亮
		},
		children:[
			...djxcRoutes
		]
	},
	{
		path:"/dqgj",
		name:"党建共建",
		component:Layout,
		redirect:'/djdd',
		icon:require('@/assets/images/djxc_icon.png'),
		meta: {
			activeMenu: '/dqgj', // 顶部导航 高亮
		},
		children:[
			...dqgjRoutes
		]
	},
	{
		path:"/xtsz",
		name:"系统设置",
		component:Layout,
		redirect:'/xtsz_dlrz',
		icon:require('@/assets/images/xtsz_icon.png'),
		meta: {
			activeMenu: '/xtsz', // 顶部导航 高亮
		},
		children:[
			...xtszRoutes
		]
	},
	{
		path:"/mess",
		name:"消息",
		component:Layout,
		redirect:"/message",
		icon:require('@/assets/images/xtsz_icon.png'),
		meta: {
			activeMenu:''
		},
		chidren:[
			// {
			// 	path:"/message",
			// 	name:"message",
			// 	meta: {
			// 		title: '消息',
			// 		requiresAuth:[1,2,3]
			// 	},
			// 	component:()=> import('@/pages/message')
			// }
			...messRoutes
		]
	}
]